import { useCallback, useState } from 'react';

import { Typography } from '@mui/material';
import { useAppDispatch } from 'app/hooks';
import { DeleteDialog } from 'common/components/deleteDialog/DeleteDialog';
import { setDialogOpen } from 'common/components/deleteDialog/deleteDialogSlice';
import { setRows } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { deleteApplicationSuite } from 'common/services/api/ApplicationSuites/ApplicationSuites.thunks';
import { DeleteDialogContentProps } from 'common/types/TypeDefs';
import { handleDeleteDialogError } from 'common/utils/errorHandlers';
import { useSnackbar } from 'notistack';

export const ApplicationSuitesDeleteDialogContent = ({
    title,
    itemId,
    editingRow
}: DeleteDialogContentProps<{ name: string }>) => {
    const { name } = editingRow ?? {};

    const dispatch = useAppDispatch();

    const [processing, setProcessing] = useState<boolean>(false);

    const { enqueueSnackbar } = useSnackbar();

    const successHandler = (): void => {
        dispatch(setDialogOpen(false));
        enqueueSnackbar('Application Suite has been deleted.', { variant: 'success' });
    };

    const applicationSuiteDeleteCallback = useCallback(() => {
        if (itemId) {
            setProcessing(true);
            dispatch(deleteApplicationSuite(itemId.toString()))
                .unwrap()
                .then((result) => {
                    dispatch(setRows(result.rows));
                    successHandler();
                    setProcessing(false);
                })
                .catch((error) => {
                    handleDeleteDialogError('Application Suite', enqueueSnackbar, extractStatusCode(error.message));
                    setProcessing(false);
                });
        }
    }, [itemId]);

    return (
        <DeleteDialog deleteCallback={applicationSuiteDeleteCallback} title={title} processing={processing}>
            <Typography color="info.light" fontSize='0.9rem' fontWeight='550'>
                Application Suite Name: <Typography component="span" color="text.primary" fontWeight="400">{name}</Typography>
            </Typography>
            <Typography color="info.light" fontSize='0.9rem' fontWeight='550'>
                Application Suite ID: <Typography component="span" color="text.primary" fontWeight="400">{itemId}</Typography>
            </Typography>
        </DeleteDialog>
    );
};
